import { useCallback, useContext, useEffect, useState } from "react";

import { ApiHelper } from "@datanac/datanac-api-toolkit/dist/api-helper";
import { _sessionManager } from "api/ApiHelper";
import { AppContext } from "App";

/**
 * Loads saved ArcCoCountyYieldOverride rows for a producer/crop year.
 * Used by ARC/PLC county summary views so payments match crop detail and position summary.
 */
export function useArcCoCountyYieldOverrides({ crop_year, apiConfig = null }) {
  const { globalState: contextGlobalState } = useContext(AppContext);
  const globalState = apiConfig || contextGlobalState;
  const producer_token = globalState?.producer_token;

  const [arcCoCountyYieldOverrides, setArcCoCountyYieldOverrides] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadOverrides = useCallback(async () => {
    if (!crop_year || !producer_token) {
      setArcCoCountyYieldOverrides([]);
      return;
    }

    try {
      setIsLoading(true);
      const api = new ApiHelper({
        baseUrl: import.meta.env.VITE_DATANAC_USERS_API_URL_BASE,
        config: {},
        sessionManager: _sessionManager,
        _instance: null,
      });
      const overrides = await api.callPost(
        "ArcCoCountyYieldOverride/search",
        { crop_year, producer_token, is_active: true },
        globalState
      );
      setArcCoCountyYieldOverrides(Array.isArray(overrides) ? overrides : []);
    } catch (err) {
      console.warn("Error loading ArcCoCountyYieldOverride:", err);
      setArcCoCountyYieldOverrides([]);
    } finally {
      setIsLoading(false);
    }
  }, [crop_year, producer_token, globalState?.producer_token, globalState?.agent_token]);

  useEffect(() => {
    loadOverrides();
  }, [loadOverrides]);

  return { arcCoCountyYieldOverrides, isLoading, reload: loadOverrides };
}
